import React from 'react';
import { GuideOpenBody } from '../../../../../interfaces/stay-guide';
import { GuideArrival } from './guide-arrival';
import { GuideCheckout } from './guide-checkout';
import { GuideEssentials } from './guide-essentials';
import { GuideFrame, GuideTarget } from './guide-frame';
import { GuideHub } from './guide-hub';
import { GuideLocal } from './guide-local';
import { GuidePhotos } from './guide-photos';
import { SectionBody } from './guide.styled';

/**
 * THE OPEN GUIDE: the frame around the hub or one section. The same tree for
 * the guest's page (sections are routes) and the host preview (sections are
 * state) — the GuideNavContext above it says which.
 */
export const GuideOpenView: React.FC<{ body: GuideOpenBody; section: GuideTarget }> = ({ body, section }) => {
  const page = (() => {
    switch (section) {
      case 'arrival':
        return <GuideArrival body={body} />;
      case 'essentials':
        return <GuideEssentials body={body} />;
      case 'local':
        return <GuideLocal body={body} />;
      case 'checkout':
        return <GuideCheckout body={body} />;
      case 'photos':
        return <GuidePhotos body={body} />;
      case 'hub':
      default:
        return <GuideHub body={body} />;
    }
  })();

  return (
    <GuideFrame body={body}>
      <SectionBody data-guide-section={section}>{page}</SectionBody>
    </GuideFrame>
  );
};
